import type { ParserSource } from './parser';
import { invariant } from '../../util/invariant';

export class SingleArrayParserSource implements ParserSource {
  private offset: number = 0;
  constructor(private array: Uint8Array) { }

  getOffset(): number {
    return this.offset;
  }

  remain(): number {
    return this.array.length - this.offset;
  }
  readUint8(): number {
    invariant(this.remain() > 0, 'SingleArrayParserSource has no more bytes');
    const byte = this.array[this.offset];
    this.offset++;
    return byte;
  }
  readUint8Array(size: number): Uint8Array {
    invariant(this.remain() >= size, 'SingleArrayParserSource reach end');
    const bytes = this.array.subarray(this.offset, this.offset + size);
    this.offset += bytes.length;
    return bytes;
  }

  subSource(size: number): ParserSource {
    return new SingleArrayParserSource(this.readUint8Array(size));
  }
}

